/** Couleurs du damier décor (herbe / zone extérieure). */
export const DECOR_CHECKER_LIGHT_CSS = 'rgba(74, 222, 128, 0.42)';
export const DECOR_CHECKER_DARK_CSS = 'rgba(22, 163, 74, 0.52)';

export const DECOR_CHECKER_LIGHT_HEX = 0x4ade80;
export const DECOR_CHECKER_DARK_HEX = 0x16a34a;

export function isDecorCheckerLight(x: number, y: number): boolean {
  return (x + y) % 2 === 0;
}

export function getDecorCheckerCss(x: number, y: number): string {
  return isDecorCheckerLight(x, y) ? DECOR_CHECKER_LIGHT_CSS : DECOR_CHECKER_DARK_CSS;
}

export function getDecorCheckerHex(x: number, y: number): number {
  return isDecorCheckerLight(x, y) ? DECOR_CHECKER_LIGHT_HEX : DECOR_CHECKER_DARK_HEX;
}
